// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import logger from "@insite/client-framework/Logger";

export const isBrowser = typeof window !== "undefined";

/**
 * Get an item from local storage.
 * @param key
 * @returns string | null
 */
export function getLocalStorage(key: string): string | null {
    if (typeof window === "undefined") {
        return null;
    }

    try {
        return window.localStorage.getItem(key);
    } catch (err) {
        return null;
    }
}

export function hasLocalStorage(key: string): boolean {
    const value = getLocalStorage(key);
    return !!(value && value.length > 0);
}

/**
 * Set an item in local storage.
 * @param key
 * @param value
 */
export function setLocalStorage(key: string, value: string): void {
    if (typeof window === "undefined") {
        return;
    }
    try {
        window.localStorage.setItem(key, value);
    } catch (err) {
        logger.warn("Local storage write failed", err);
    }
}

/**
 * Remove an item from local storage.
 * @param key
 */
export function removeLocalStorage(key: string): void {
    if (typeof window === "undefined") {
        return;
    }

    try {
        window.localStorage.removeItem(key);
    } catch (err) {
        logger.warn("Local storage remove failed", err);
    }
}
